import { ChipProps } from '@mui/material';
import { NavItemType } from 'types/menu';
import {
  feedbackGroup,
  getEaConnectGroup,
  getGeneralGroup,
  getTcAnalyzerGroup,
  getTcCopierGroup,
  getTradingToolsGroup,
  growthMonetizationGroup
} from './menu-items';

// The chip What's New puts on an announced menu item; posts decide when it shows and when it expires.
export const NEW_CHIP: ChipProps = { label: 'NEW', color: 'primary', size: 'small', variant: 'filled' };

// The groups pinned to the bottom of the sidebar, the same for everyone.
export const BOTTOM_GROUPS: NavItemType[] = [growthMonetizationGroup];

/** Every item in a menu tree, groups and collapses included, parents before their children. */
export const flattenMenu = (items: NavItemType[]): NavItemType[] => items.flatMap((item) => [item, ...flattenMenu(item.children ?? [])]);

/** Every menu item any user can have, whatever their plan or roles. For lookups by id or url, not for drawing the menu. */
export const allMenuItems = (): NavItemType[] =>
  flattenMenu([
    getGeneralGroup(),
    getTcCopierGroup(),
    getEaConnectGroup(),
    getTcAnalyzerGroup(true),
    getTradingToolsGroup(false, true),
    feedbackGroup,
    ...BOTTOM_GROUPS
  ]);

let itemsById: Map<string, NavItemType> | undefined;
/** A menu item by id, from the full menu, built once on first use. */
export const findMenuItem = (id: string): NavItemType | undefined => {
  if (!itemsById) itemsById = new Map(allMenuItems().flatMap((item) => (item.id ? [[item.id, item] as const] : [])));
  return itemsById.get(id);
};

/** The menu tree with a NEW chip on each announced item. An item's own chip (BETA, EARLY ACCESS) is kept. */
export const withNewChips = (items: NavItemType[], newIds: Set<string>): NavItemType[] =>
  newIds.size
    ? items.map((item) => ({
        ...item,
        ...(item.id && newIds.has(item.id) && !item.chip && { chip: NEW_CHIP, isNew: true }),
        ...(item.children && { children: withNewChips(item.children, newIds) })
      }))
    : items;
